module.exports = __webpack_public_path__ + "img/home-blue.b40076a5.svg";